var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12V7.5C25.5 7.10218 25.342 6.72064 25.0607 6.43934C24.7794 6.15804 24.3978 6 24 6H9C8.20435 6 7.44129 6.31607 6.87868 6.87868C6.31607 7.44129 6 8.20435 6 9M6 9C6 9.79565 6.31607 10.5587 6.87868 11.1213C7.44129 11.6839 8.20435 12 9 12H27C27.3978 12 27.7794 12.158 28.0607 12.4393C28.342 12.7206 28.5 13.1022 28.5 13.5V18M6 9V27C6 27.7956 6.31607 28.5587 6.87868 29.1213C7.44129 29.6839 8.20435 30 9 30H27C27.3978 30 27.7794 29.842 28.0607 29.5607C28.342 29.2794 28.5 28.8978 28.5 28.5V24M30 18V24H24C23.2044 24 22.4413 23.6839 21.8787 23.1213C21.3161 22.5587 21 21.7956 21 21C21 20.2044 21.3161 19.4413 21.8787 18.8787C22.4413 18.3161 23.2044 18 24 18H30Z",
    stroke: "#F74439",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7fa03e353c30d4f94f3900948556dafc.svg";
export { ForwardRef as ReactComponent };